'use strict';

/**
 * styles
 */

import './general/scss/font-face.scss'
import './general/scss/index.scss'

/**
 * base
 */
//intersection observer polyfill
import 'intersection-observer';

//start font loading stuff as soon as possible
import './general/js/font-loader';

import './general/js/jquery-plugins';
//import './general/js/cookie-management';

/**
 * components
 */
import './components/select';
import './components/header';
import './components/footer';
import './components/hero';
import './components/hero-column';
import './components/next-auction-panel';
import './components/home';
import './components/widget-list';
import './components/upcoming-auctions';
import './components/promo';
import './components/full-width-promo';
import './components/owl-carousel';
import './components/lots-carousel';
import './components/lot-item';
import './components/responsive-images';
import './components/section';
import './components/buying-selling';
import './components/quotes-carousel';
import './components/form';
import './components/signup';
import './components/flip-number';
import './components/auction-results';
import './components/latest-news';
import './components/news-article-item';
import './components/lot-details';
import './components/banners';
import './components/energy-certificate';
import './components/collapsed';
import './components/hero-video';
import './components/modal';
import './components/auth-forms';
import './components/auth-modal';
import './components/featured-lots';
import './components/tabs';
import './components/profile';
import './components/register';
import './components/account-settings';
import './components/spinner';
import './components/page-spinner';
import './components/reset-password-form';
import './components/lots-search';
import './components/about';
import './components/contact';
import './components/radio-switch';
import './components/gmap';
import './components/card';
import './components/bidding-cards';
import './components/page-switch-tabs';
import './components/links-list';
import './components/cta-block';
//import './components/cookie-warning';
import './components/cookie-management';
import './components/favorites-button';
import './components/listing';
import './components/predictive-search';
import './components/news-search';
import './components/article';
import './components/news-article';
import './components/request-catalogue';
import './components/offer';
import './components/social';
import './components/form-result-replacer';
import './components/shifted-content';
import './components/modal-form';
import './components/download-catalogue';
import './components/sell-lot';
import './components/disclaimer';
import './components/notifications';
import './components/get-document-form';
import './components/recaptcha';
import './components/video';
import './components/register-to-bid';
import './components/file-input';
import './components/show-rule';

/**
 * init app
 */
import app from './general/js/app';

app.init();

/**
 * require svg
 */
let files = require.context("general/svg", true, /^\.\/.*\.svg/);
files.keys().forEach(files);



// WEBPACK FOOTER //
// ./app/index.js